import { useState } from "react";
import { toast } from "sonner";
import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { errMsg, fmtDate, inr, STATUS_LABEL } from "@/lib/api";
import { useAdminApi } from "@/lib/admin";
import { printPackageDoc } from "@/lib/invoice";
import { useSettings } from "@/components/site/Footer";
import { useLoad, PageHead, DataTable, Td, NativeSelect } from "@/components/admin/kit";

const Fulfil = ({ o, reload }) => {
  const call = useAdminApi();
  const [status, setStatus] = useState("");
  const [tracking, setTracking] = useState(o.tracking || "");
  if (o.payment_status !== "paid")
    return o.status === "awaiting_payment" ? <Button size="sm" variant="outline" className="text-red-600" onClick={() => window.confirm(`Cancel unpaid order ${o.order_number}?`) && call("patch", `/admin/mlm/package-orders/${o.id}`, { status: "cancelled" }).then(() => { toast.success("Order cancelled"); reload(); }).catch((e) => toast.error(errMsg(e)))} data-testid={`pkgo-cancel-${o.id}`}>Cancel unpaid</Button> : <span className="text-xs text-slate-500">—</span>;
  const save = async () => {
    try {
      await call("patch", `/admin/mlm/package-orders/${o.id}`, { status, tracking });
      toast.success("Updated");
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="flex flex-wrap gap-2">
      <NativeSelect value={status} onChange={setStatus} options={["processing", "packed", "shipped", "delivered"]} placeholder="Set status" testid={`pkgo-status-${o.id}`} />
      <Input value={tracking} onChange={(e) => setTracking(e.target.value)} placeholder="Tracking / courier" className="h-9 w-40" />
      <Button size="sm" disabled={!status} onClick={save}>Save</Button>
    </div>
  );
};

export default function PackageOrders() {
  const [q, setQ] = useState("");
  const [rows, reload] = useLoad("/admin/mlm/package-orders", { q: q || undefined });
  const company = useSettings();
  return (
    <div>
      <PageHead title="Package Orders"><Input placeholder="Search order / distributor" value={q} onChange={(e) => setQ(e.target.value)} className="h-9 w-64" data-testid="pkgo-search" /></PageHead>
      <p className="mb-4 text-sm text-slate-500">Package payments and refunds also appear under Payments & Refunds (type: package).</p>
      <DataTable head={["Order", "Distributor", "Package", "Amount", "Status", "Payment / Invoice", "Deliver to", "Fulfilment"]} testid="package-orders-table">
        {(rows || []).map((o) => (
          <tr key={o.id}>
            <Td><p className="font-semibold">{o.order_number}</p><p className="text-xs text-slate-500">{fmtDate(o.created_at, true)}</p></Td>
            <Td>{o.buyer_name}<p className="text-xs text-slate-500">{o.distributor_id}</p></Td><Td>{o.package_name} × {o.quantity || 1}</Td><Td>{inr(o.amount)}</Td>
            <Td>{STATUS_LABEL[o.status] || o.status}{o.tracking && <p className="text-xs text-slate-500">{o.tracking}</p>}</Td>
            <Td><p className="text-xs capitalize">{o.payment_status}{o.razorpay_payment_id && ` · ${o.razorpay_payment_id}`}</p><Button size="sm" variant="ghost" onClick={() => printPackageDoc(o, company)} data-testid={`pkgo-invoice-${o.id}`}><Printer className="h-4 w-4" /> {o.invoice_no || "Confirmation"}</Button></Td>
            <Td className="text-xs">{o.ship_to?.full_name}, {o.ship_to?.address}, {o.ship_to?.district}, {o.ship_to?.state} {o.ship_to?.pincode} · {o.ship_to?.mobile}</Td>
            <Td><Fulfil o={o} reload={reload} /></Td>
          </tr>
        ))}
      </DataTable>
    </div>
  );
}
